import { discoverKinds, type ServedKind } from "@nodus/api";
import { useQuery } from "@tanstack/react-query";
import { useRuntime } from "./runtime";

/** The kinds this org is served, by kind name; stages come from the served version (ui-spec §4.7). */
export function useServedKinds(org: string): Map<string, ServedKind> | undefined {
  const { client } = useRuntime();
  const q = useQuery({
    queryKey: [org, "", "discovery"],
    queryFn: () => discoverKinds(client, org),
    staleTime: 10 * 60_000,
  });
  return q.data ? new Map(q.data.map((k) => [k.kind, k])) : undefined;
}
